"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareTeamList = void 0;
const react_1 = __importStar(require("react"));
const provider_components_1 = require("@kyruus/provider-components");
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../lib/messages"));
const tracking_utils_1 = require("../../lib/tracking.utils");
const constants_1 = require("../../lib/constants");
const styles_1 = require("./styles");
const INITIAL_PROVIDERS_TO_SHOW = 4;
exports.CareTeamList = (0, intl_1.injectIntl)(({ intl, careTeamProviders, createAvailabilityUrl, createProviderUrl, track }) => {
    const [isListExpanded, setIsListExpanded] = (0, react_1.useState)(false);
    const handleClickShowMore = () => {
        if (isListExpanded) {
            (0, tracking_utils_1.trackShowMoreClick)(track, 'hide', provider_components_1.CARE_TEAM);
        }
        else {
            (0, tracking_utils_1.trackShowMoreClick)(track, 'show', provider_components_1.CARE_TEAM);
        }
        setIsListExpanded(!isListExpanded);
    };
    const showMoreAriaLabel = isListExpanded
        ? intl.formatMessage(messages_1.default.careTeamShowLessAriaLabel)
        : intl.formatMessage(messages_1.default.careTeamShowMoreAriaLabel);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.CareTeamProviderList, { providers: careTeamProviders.slice(0, INITIAL_PROVIDERS_TO_SHOW), track: track, createAvailabilityUrl: createAvailabilityUrl, createProviderUrl: createProviderUrl, renderType: provider_components_1.CARE_TEAM }),
        careTeamProviders.length > INITIAL_PROVIDERS_TO_SHOW ? (react_1.default.createElement(react_1.default.Fragment, null,
            isListExpanded && (react_1.default.createElement(styles_1.CareTeamExpandedProviderList, { providers: careTeamProviders.slice(INITIAL_PROVIDERS_TO_SHOW), track: track, createAvailabilityUrl: createAvailabilityUrl, createProviderUrl: createProviderUrl, renderType: provider_components_1.CARE_TEAM })),
            react_1.default.createElement(styles_1.ShowMoreButton, { type: "button", onClick: handleClickShowMore, "aria-label": showMoreAriaLabel, "aria-expanded": isListExpanded, "aria-controls": constants_1.PROFILE_SECTION_IDS.CARE_TEAM }, isListExpanded
                ? intl.formatMessage(messages_1.default.careTeamShowLess)
                : intl.formatMessage(messages_1.default.careTeamShowMore)))) : null));
});
//# sourceMappingURL=CareTeamList.js.map